import { useEffect, useRef } from 'react';
import { ALL_EQUIPMENTS } from '../../../../shared/types/oeeRow.ts';
import { useResizeObserver } from '../../../hooks/useResizeObserver.ts';
import { trpc } from '../../../utils/trpc/trpc.ts';
import { drawReportGraph } from '../drawReportGraph.ts';
import { ReportSettings } from '../report-settings/reportSettings.ts';
import { ReportGraphContainer } from '../reportGraphContainer.tsx';
import { prepareAvailabilityData } from './prepareAvailabilityData.ts';


interface Props {
    style?: React.CSSProperties;
    reportSettings: ReportSettings;
    operatorFooterLabelsByPeriod?: string[][];
    onOperatorFooterClick?: (periodIndex: number) => void;
}

export function AvailabilityGraph({
    style,
    reportSettings,
    operatorFooterLabelsByPeriod,
    onOperatorFooterClick,
}: Props) {
    const graphContainerRef = useRef<HTMLDivElement>(null);
    const dimensions = useResizeObserver(graphContainerRef);

    const { data: oeeData, isFetching } = trpc.graphsData.getOee.useQuery({
        windowType: 'shift',
        equipment: ALL_EQUIPMENTS,
        start: {
            start: reportSettings.first.start,
            end: reportSettings.last.end,
        },
    }, { refetchOnWindowFocus: false, });

    useEffect(() => {
        if (!graphContainerRef.current || !oeeData) return;
        const data = prepareAvailabilityData(oeeData, reportSettings);
        drawReportGraph(graphContainerRef.current!, data, operatorFooterLabelsByPeriod, onOperatorFooterClick);
    }, [oeeData, reportSettings, operatorFooterLabelsByPeriod, onOperatorFooterClick, dimensions]);


    if (reportSettings.first.start > reportSettings.last.start) return 'Invalid date range';
    return (
        <ReportGraphContainer
            style={{ ...style, height: '100%' }}
            containerRef={graphContainerRef}
            isLoading={isFetching}
        />
    );
}
